import styled from '@emotion/styled';
import kebabCase from 'lodash/kebabCase';
import { useState, useRef } from 'react';
import innerText from 'react-innertext';

import Text from './PageBuilder/utilities/Text';
import Icon from './oc-icon';
import { useAccessibleInteractivity } from '../../hooks';

const Container = styled.div`
  width: 100%;
`;

const Header = styled.div`
  user-select: none;
  position: relative;
  background-color: #f8f8f8;
  border-bottom: 1px solid #bcbcbc;
  padding: 10px 35px 10px 16px;
  transition: background-color 0.5s, padding-left 0.4s;
  cursor: pointer;
  width: 100%;

  &:hover {
    background-color: #f2f2f2;
    padding-left: 20px;
  }

  .fa {
    font-size: 18px;
    position: absolute;
    right: 13px;
    top: 11px;
  }
`;

const Content = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  padding: 16px;
  background-color: white;
`;

const Dropdown = ({ open: defaultOpen, label, dataTrackAccordion, children, id }) => {
  const [isOpen, toggleOpen] = useState(!!defaultOpen);
  const ref = useRef();
  const onDropdownToggle = () => {
    toggleOpen(!isOpen);
  };

  useAccessibleInteractivity(ref, onDropdownToggle);

  const headingId = id || `accordion-${kebabCase(innerText(label))}`;
  const panelId = `${headingId}-panel`;

  return (
    <Container role="region" aria-labelledby={headingId}>
      <Header
        ref={ref}
        id={headingId}
        data-track={isOpen ? 'conceal' : 'reveal'}
        data-track-accordion={dataTrackAccordion || label}
        aria-expanded={isOpen}
        aria-controls={panelId}
        role="button"
      >
        <Text content={label} />
        <Icon type={isOpen ? 'minus' : 'plus'} />
      </Header>

      <Content id={panelId} isOpen={isOpen} aria-hidden={!isOpen}>
        {children}
      </Content>
    </Container>
  );
};

export default Dropdown;
